export const CompactSvg = ({ active }: { active: boolean }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
    <path
      d="M2.06879 0.571502C1.25768 0.637533 0.637045 1.25817 0.571013 2.06928C0.487839 3.09404 0.399902 4.72928 0.399902 7.06706C0.399902 9.40483 0.487839 11.0401 0.571013 12.0648C0.637045 12.8759 1.25768 13.4966 2.06879 13.5626C3.09355 13.6458 4.72879 13.7337 7.06657 13.7337C9.40435 13.7337 11.0396 13.6458 12.0643 13.5626C12.8755 13.4966 13.4961 12.8759 13.5621 12.0648C13.6453 11.0401 13.7332 9.40483 13.7332 7.06706C13.7332 4.72928 13.6453 3.09404 13.5621 2.06928C13.4961 1.25817 12.8755 0.637533 12.0643 0.571502C11.0396 0.488327 9.40435 0.400391 7.06657 0.400391C4.72879 0.400391 3.09355 0.488327 2.06879 0.571502Z"
      stroke={active ? "#ccf54e" : "#F0F0F0"}
      stroke-width="0.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.61753 11.4838C8.10928 11.4514 7.76166 11.0482 7.74452 10.5393C7.72356 9.89425 7.70166 8.81044 7.70166 7.06758C7.70166 5.32473 7.72325 4.24092 7.74483 3.59615C7.76166 3.08695 8.10928 2.68377 8.61785 2.65139C8.95154 2.63142 9.28578 2.622 9.62007 2.62314C10.0191 2.62314 10.3394 2.63393 10.5934 2.64949C11.1163 2.68123 11.4709 3.10219 11.4823 3.62568C11.4972 4.27393 11.5112 5.35108 11.5112 7.06758C11.5112 8.78409 11.4969 9.86123 11.4826 10.5095C11.4709 11.033 11.1163 11.4536 10.5937 11.4857C10.3398 11.5012 10.0191 11.512 9.62007 11.512C9.28568 11.5132 8.95133 11.5037 8.61753 11.4838Z"
      stroke={active ? "#ccf54e" : "#F0F0F0"}
      stroke-width="0.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const SyncSvg = ({ active }: { active: boolean }) => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 7a5 5 0 0 1 8.5-3.5L12 2v3H9" stroke={active ? "#ccf54e" : "#f0f0f0"} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" opacity={active ? 1 : 0.7} />
    <path d="M12 7a5 5 0 0 1-8.5 3.5L2 12V9h3" stroke={active ? "#ccf54e" : "#f0f0f0"} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" opacity={active ? 1 : 0.7} />
  </svg>
);

export const TemperatureSvg = ({ active }: { active: boolean }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M8.79982 3.20215C8.79982 2.99004 8.71543 2.78573 8.56545 2.63574C8.41549 2.48596 8.21198 2.40234 8.00002 2.40234C7.78805 2.40237 7.58453 2.48592 7.43459 2.63574C7.2846 2.78573 7.20021 2.99004 7.20021 3.20215V9.52441C7.20021 9.66732 7.12378 9.79964 7.00002 9.87109C6.61905 10.0912 6.32076 10.4305 6.15236 10.8369C5.98392 11.2436 5.95445 11.695 6.06838 12.1201C6.18231 12.5453 6.43403 12.9205 6.78322 13.1885C7.13238 13.4564 7.55992 13.6015 8.00002 13.6016C8.44018 13.6016 8.86859 13.4564 9.21779 13.1885C9.56674 12.9206 9.81777 12.5451 9.93166 12.1201C10.0456 11.695 10.0161 11.2436 9.84767 10.8369C9.67925 10.4304 9.38103 10.0911 9.00002 9.87109C8.87626 9.79964 8.79982 9.66732 8.79982 9.52441V3.20215ZM9.59963 9.30371C10.038 9.60873 10.3813 10.0348 10.5869 10.5312C10.8227 11.1005 10.8636 11.732 10.7041 12.3271C10.5446 12.9224 10.193 13.4481 9.70412 13.8232C9.21521 14.1984 8.61627 14.4023 8.00002 14.4023C7.38378 14.4023 6.78481 14.1984 6.29592 13.8232C5.80707 13.4481 5.45542 12.9223 5.29592 12.3271C5.13641 11.7319 5.17824 11.1006 5.41408 10.5312C5.61962 10.0351 5.96232 9.60968 6.40041 9.30469V3.20215C6.40041 2.77787 6.56915 2.37032 6.86916 2.07031C7.16913 1.77046 7.57587 1.60159 8.00002 1.60156C8.42415 1.60156 8.83089 1.7705 9.13088 2.07031C9.43089 2.37032 9.59963 2.77787 9.59963 3.20215V9.30371Z"
      fill={active ? "#ccf54e" : "#EEEEEE"}
    />
  </svg>
);

export const FullScreenSvg = ({ active }: { active: boolean }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M5.33333 2H3.33333C2.97971 2 2.64057 2.14048 2.39052 2.39052C2.14048 2.64057 2 2.97971 2 3.33333V5.33333"
      stroke={active ? "#ccf54e" : "#F0F0F0"}
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.0013 5.33333V3.33333C14.0013 2.97971 13.8608 2.64057 13.6108 2.39052C13.3607 2.14048 13.0216 2 12.668 2H10.668"
      stroke={active ? "#ccf54e" : "#F0F0F0"}
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2 10.666V12.666C2 13.0196 2.14048 13.3588 2.39052 13.6088C2.64057 13.8589 2.97971 13.9993 3.33333 13.9993H5.33333"
      stroke={active ? "#ccf54e" : "#F0F0F0"}
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.668 13.9993H12.668C13.0216 13.9993 13.3607 13.8589 13.6108 13.6088C13.8608 13.3588 14.0013 13.0196 14.0013 12.666V10.666"
      stroke={active ? "#ccf54e" : "#F0F0F0"}
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const LayersIcon = ({ active }: { active: boolean }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
    <path
      d="M6.65576 9.56837C5.42692 9.07709 4.8125 8.83144 4.8125 8.52578C4.8125 8.22012 5.42692 7.97509 6.65576 7.48319L8.39321 6.78833C9.62204 6.29642 10.2371 6.05078 11 6.05078C11.7635 6.05078 12.378 6.29642 13.6068 6.78833L15.3442 7.48319C16.5731 7.97447 17.1875 8.22012 17.1875 8.52578C17.1875 8.83144 16.5731 9.07647 15.3442 9.56837L13.6068 10.2632C12.378 10.7558 11.7629 11.0008 11 11.0008C10.2365 11.0008 9.62204 10.7551 8.39321 10.2638L6.65637 9.56776L6.65576 9.56837Z"
      stroke={active ? "#CCF54E" : "#F0F0F0"}
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.14271 9.76367L6.65576 9.95858C5.42692 10.4499 4.8125 10.6961 4.8125 11.0012C4.8125 11.3062 5.42692 11.5519 6.65576 12.0438L8.39321 12.7386C9.62204 13.2311 10.2371 13.4762 11 13.4762C11.7635 13.4762 12.378 13.2305 13.6068 12.7392L15.3442 12.0438C16.5731 11.5525 17.1875 11.3062 17.1875 11.0012C17.1875 10.6961 16.5731 10.4505 15.3442 9.95858L14.8573 9.76367M7.14271 12.2387L6.65576 12.4336C5.42692 12.9249 4.8125 13.1711 4.8125 13.4762C4.8125 13.7818 5.42692 14.0269 6.65576 14.5188L8.39321 15.2136C9.62204 15.7061 10.2371 15.9512 11 15.9512C11.7635 15.9512 12.378 15.7055 13.6068 15.2136L15.3442 14.5188C16.5731 14.0275 17.1875 13.7818 17.1875 13.4762C17.1875 13.1711 16.5731 12.9255 15.3442 12.4336L14.8573 12.2387"
      stroke={active ? "#CCF54E" : "#F0F0F0"}
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CaratClosedIcon = ({ active }: { active: boolean }) => (<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M9.63091 8.42375L6.96863 11.086C6.59065 11.464 5.94436 11.1963 5.94436 10.6618L5.94436 5.3372C5.94436 4.80266 6.59065 4.53496 6.96863 4.91294L9.63091 7.57522C9.86523 7.80954 9.86523 8.18944 9.63091 8.42375Z" fill="#EEEEEE"/>
</svg>);

export const GraphSvg = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 20" fill="none">
        <path d="M2.5 2.5V15.8333C2.5 16.2754 2.67559 16.6993 2.98816 17.0118C3.30072 17.3244 3.72464 17.5 4.16667 17.5H17.5" stroke="#F0F0F0" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M5.83301 13.3346C6.24967 11.668 7.08301 7.5013 9.16634 7.5013C10.833 7.5013 10.833 10.0013 12.4997 10.0013C14.583 10.0013 16.2497 5.83464 16.6663 4.16797" stroke="#F0F0F0" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
);

export const SubsystemSvg = ({ active }: { active: boolean }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
        <rect x="2" y="2" width="5" height="5" stroke={active ? "#ccf54e" : "#F0F0F0"} strokeWidth="1" fill="none" />
        <rect x="11" y="2" width="5" height="5" stroke={active ? "#ccf54e" : "#F0F0F0"} strokeWidth="1" fill="none" />
        <rect x="2" y="11" width="5" height="5" stroke={active ? "#ccf54e" : "#F0F0F0"} strokeWidth="1" fill="none" />
        <rect x="11" y="11" width="5" height="5" stroke={active ? "#ccf54e" : "#F0F0F0"} strokeWidth="1" fill="none" />
    </svg>
);

export const QualitySettingsIcon = ({ active }: { active: boolean }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <circle cx="4" cy="8" r="1" fill={active ? "#ccf54e" : "#F0F0F0"} />
        <circle cx="12" cy="8" r="1" fill={active ? "#ccf54e" : "#F0F0F0"} />
        <circle cx="8" cy="4" r="1" fill={active ? "#ccf54e" : "#F0F0F0"} />
        <circle cx="8" cy="12" r="1" fill={active ? "#ccf54e" : "#F0F0F0"} />
        <line x1="5.5" y1="7" x2="10.5" y2="9" stroke={active ? "#ccf54e" : "#F0F0F0"} strokeWidth="0.8" />
        <line x1="5" y1="9" x2="10" y2="7" stroke={active ? "#ccf54e" : "#F0F0F0"} strokeWidth="0.8" />
    </svg>
);